import { Comparison } from '@/features/landing/sections/Comparison'
import { CTABand } from '@/features/landing/sections/CTABand'
import { Footer } from '@/features/landing/sections/Footer'
import { ForClanLeaders } from '@/features/landing/sections/ForClanLeaders'
import { FounderNote } from '@/features/landing/sections/FounderNote'
import { FoundingSquad } from '@/features/landing/sections/FoundingSquad'
import { Hero } from '@/features/landing/sections/Hero'
import { HowItWorks } from '@/features/landing/sections/HowItWorks'
import { MobileFirst } from '@/features/landing/sections/MobileFirst'
import { Nav } from '@/features/landing/sections/Nav'
import { Pricing } from '@/features/landing/sections/Pricing'
import { USPGrid } from '@/features/landing/sections/USPGrid'

export default function Landing() {
  return (
    <div className="min-h-dvh bg-bg text-fg">
      <Nav />
      <main>
        <Hero />
        {/* Order matters: visitors need to know WHAT e404 does before
            they care about the fragmentation argument or pricing.
            ForClanLeaders sits right after the USP grid because the
            outbound Leaders Pack email lands on this page (#for-leaders)
            — the decision-maker gets their section before pricing. */}
        <HowItWorks />
        <Comparison />
        <USPGrid />
        <ForClanLeaders />
        <FoundingSquad />
        <Pricing />
        <MobileFirst />
        <FounderNote />
        <CTABand />
      </main>
      <Footer />
    </div>
  )
}
